"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TooltipContent = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _Alert = require("b2b-components/theme/components/Alert");
var _DataTable = require("b2b-components/theme/components/DataTable");
var _classnames = _interopRequireDefault(require("classnames"));
var _dataMappers = require("../../utils/dataMappers");
require("./TooltipContent.scss");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj["default"] = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      (0, _defineProperty2["default"])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
var TooltipContent = function TooltipContent(_ref) {
  var className = _ref.className,
    stockCount = _ref.stockCount,
    quantityOrdered = _ref.quantityOrdered,
    isSpecialOrder = _ref.isSpecialOrder,
    text = _ref.text;
  var rootClassName = (0, _classnames["default"])('cds-StockCountTooltip', className);
  var isReadyForShipment = stockCount > 0;
  var displayQuantityOrdered = !!(Array.isArray(quantityOrdered) && quantityOrdered.length);
  var alertStyleType = isReadyForShipment ? _Alert.ALERT_STYLE_TYPE.success : _Alert.ALERT_STYLE_TYPE.warning;
  var alertMessage = isReadyForShipment ? /*#__PURE__*/_react["default"].createElement("span", {
    dangerouslySetInnerHTML: {
      __html: text.readyForShipment
    }
  }) : /*#__PURE__*/_react["default"].createElement("span", null, text.notReadyForShipment);
  var transformedQuantityOrdered = (0, _react.useMemo)(function () {
    if (Array.isArray(quantityOrdered) && displayQuantityOrdered) {
      var unknownDateOrders = [];
      var knownDateOrders = quantityOrdered.reduce(function (orders, order) {
        if (order.deliveryDate) {
          orders.push(order);
        } else {
          unknownDateOrders.push(_objectSpread(_objectSpread({}, order), {}, {
            deliveryDate: text.unknownDeliveryDate
          }));
        }
        return orders;
      }, []);
      return [].concat((0, _toConsumableArray2["default"])(knownDateOrders), unknownDateOrders).map(_dataMappers.transformQuantityOrderedToDataTable);
    }
    return [];
  }, [quantityOrdered, displayQuantityOrdered, text.unknownDeliveryDate]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: rootClassName
  }, isSpecialOrder && stockCount <= 0 && /*#__PURE__*/_react["default"].createElement("div", {
    className: 'cds-StockCountTooltip-SpecialOrder'
  }, text.specialOrder.explanation), (!isSpecialOrder || isSpecialOrder && stockCount > 0) && /*#__PURE__*/_react["default"].createElement(_Alert.Alert, {
    displayType: _Alert.ALERT_DISPLAY_TYPE.text,
    styleType: alertStyleType,
    className: 'cds-StockCountTooltip-Alert'
  }, alertMessage), !isSpecialOrder && displayQuantityOrdered && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: 'cds-StockCountTooltip-Title'
  }, text.deliveryDates), /*#__PURE__*/_react["default"].createElement(_DataTable.DataTable, {
    header: [{
      value: text.date
    }, {
      value: text.orderedQuantity
    }],
    rows: transformedQuantityOrdered,
    className: 'cds-StockCountTable'
  })));
};
exports.TooltipContent = TooltipContent;